import { render } from "./TheSubscriptionsProductsList.vue?vue&type=template&id=325df639"
import script from "./TheSubscriptionsProductsList.vue?vue&type=script&lang=js"
export * from "./TheSubscriptionsProductsList.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__